import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';

import { TrekCard } from '../../Cards';
import { fetchMyTreks } from '../../../redux/actions/trekActions';
import { useEffectOnFirstRender } from '../../../hooks';

type Props = {
  myTreks: Array<Object>,
  fetchTreks: () => void,
};

const mapStateToProps = ({ schema }) => ({
  myTreks: Object.values(schema.myTreks.byId),
});

const mapDispatchToProps = dispatch => ({
  fetchTreks: () => dispatch(fetchMyTreks()),
});

function UserTreksPannel({ myTreks, fetchTreks }: Props) {
  useEffectOnFirstRender(fetchTreks);

  if (isEmpty(myTreks)) return null;

  return (
    <Row>
      {myTreks.map(trek => (
        <Col xl="4" lg="4" md="6" key={trek.id}>
          <TrekCard cardData={trek} />
        </Col>
      ))}
    </Row>
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserTreksPannel);



// WEBPACK FOOTER //
// ./src/components/Profile/TreksPannel/UserTreksPannel.jsx